export type OrgTypeSlug = 'SUPPLIER' | 'OWNER' | 'SERVICE_USER';

export const OrgTypeSlug = {
  SUPPLIER: 'SUPPLIER' as OrgTypeSlug,
  OWNER: 'OWNER' as OrgTypeSlug,
  SERVICEUSER: 'SERVICE_USER' as OrgTypeSlug,
};
